// application
import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { VehicleYearRequest } from '@/main/models/request';

export abstract class IYearApi {
  abstract getVehicleYear(): Promise<AxiosResponse<Result<KeyValue[]>>>;
  abstract getVehicleYearByManufacturerAndModel(
    request: VehicleYearRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
